<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="tw-p-4"
  >
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="formData.firstName"
          :counter="50"
          :counter-value="nameLenght"
          :rules="[validateMaxLength()]"
          persistent-hint
          label="Host given name"
          name="host-given-name"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="formData.lastName"
          :counter="50"
          :counter-value="nameLenght"
          label="Host last name"
          name="host-last-name"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="formData.subtitle"
          :counter="60"
          :rules="formValidation.subtitle"
          label="Subtitle for the Host"
          name="subtitle"
          persistent-hint
          hint="Optional. This text is Host specific and will be displayed in every room."
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="validate"
        >
          <slot name="confirmButtonText" />
        </v-btn>

        <v-btn
          color="error"
          class="mr-4"
          @click="$emit('form-cancel')"
        >
          <slot name="cancelButtonText" />
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash-es';

export default {
  props: {
    presenterData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data: () => ({
    valid: true,
    formData: {
      firstName: '',
      lastName: '',
      subtitle: '',
    },
    formValidation: {
      subtitle: [
        (v) => (v.length <= 60 || 'Subtitle must be less than 60 characters long.'),
      ],
    },
  }),

  watch: {
    presenterData: {
      deep: true,
      handler(newVal) {
        if (!isEmpty(newVal)) this.formData = cloneDeep(newVal);
      },
    },
  },

  created() {
    if (!isEmpty(this.presenterData)) this.formData = cloneDeep(this.presenterData);
  },

  methods: {
    nameLenght() {
      return `${this.formData.firstName} ${this.formData.lastName}`.length - 1;
    },

    validateMaxLength() {
      return this.nameLenght() < 51 || 'First and Last name combined cannot exceed 50 characters in length';
    },

    validate() {
      if (this.$refs.form.validate()) this.$emit('form-submit', { ...this.formData });
    },
  },
};
</script>
